import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Paywall interceptor — the backend returns HTTP 402 with `{paywall: true,
// ...}` when a route can't run. Two variants:
//   1. `billing_block: true` → the church's billing_status isn't active or
//      grandfathered. CTA takes them to /crm/billing to complete checkout.
//   2. `tool_key: "..."` → the tool isn't in tools_enabled. CTA takes them
//      to /crm/billing to add it.
// We debounce to avoid stacking toasts if several requests fail at once.
let _lastPaywallAt = 0;
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const body = err?.response?.data;
    if (status === 402 && body?.paywall) {
      const now = Date.now();
      if (now - _lastPaywallAt > 4000) {
        _lastPaywallAt = now;
        const cta = body.billing_block ? "Complete checkout" : "Enable it";
        const fallback = body.billing_block
          ? "Complete your subscription to keep using this feature."
          : `${body.tool_label || "This tool"} isn't enabled for your church.`;
        toast.error(body.detail || fallback, {
          action: {
            label: cta,
            onClick: () => { window.location.href = "/crm/billing"; },
          },
          duration: 6000,
        });
      }
    }
    return Promise.reject(err);
  }
);
